import React, { Component } from 'react';
import { Tooltip, Popover } from 'antd';
import CommonBackButton from 'containers/CommonBackButton';
import { withRouter } from 'react-router-dom';
import OfferWise from 'components/Transaction/Offer/OfferWise';
import findIndex from 'lodash/findIndex';
import sum from 'lodash/sum';
import Table from 'components/Inventory/TableBack';
import { TRACK_TYPES } from 'constants/Common';
import { createDiamondTrack } from 'services/DiamondApi';
import { historyDataPaginate } from 'services/DiamondBlockApi';
import OpenNotification from 'constants/OpenNotifications';
import ListingWrapper from 'containers/ListingWrapper';
import ListingTableWrapper from 'containers/ListingTableWrapper';
import CommonApi from 'constants/CommonApi';
import UtilService from 'services/util';
import Messages from 'constants/Messages';
import Storage from 'services/storage';
import { searchFn } from 'components/Inventory/inventoryFunctions';
import uniq from 'lodash/uniq';
import moment from 'moment';
import find from 'lodash/find';
import { isEmpty, isArray } from 'util/utils';
import { getOfficeConfig } from 'services/OfficeApi';
import { filterList } from 'components/Inventory/table-utils';
import CellInputHeader from './CellInputHeader';
import { RowSelectService } from 'services/RowSelectService';

const caratRange = [
  '0.30-0.33',
  '0.34-0.36',
  '0.37-0.39',

  '0.40-0.44',
  '0.45-0.49',

  '0.50-0.54',
  '0.55-0.59',
  '0.60-0.64',
  '0.65-0.69',
  '0.70-0.73',

  '0.74-0.76',
  '0.77-0.79',

  '0.80-0.83',
  '0.84-0.87',
  '0.88-0.89',

  '0.90-0.95',
  '0.96-0.99',

  '1.00-1.05',
  '1.06-1.09',
  '1.10-1.14',
  '1.15-1.19',
  '1.20-1.24',
  '1.25-1.29',
  '1.30-1.34',
  '1.35-1.39',
  '1.40-1.44',
  '1.45-1.49',
  '1.50-1.54',
  '1.55-1.59',
  '1.60-1.64',
  '1.65-1.69',
  '1.70-1.74',
  '1.75-1.79',
  '1.80-1.84',
  '1.85-1.89',
  '1.90-1.94',
  '1.95-1.99',

  '2.00-2.19',
  '2.20-2.39',
  '2.40-2.49',
  '2.50-2.69',
  '2.70-2.89',
  '2.90-2.99',

  '3.00-3.49',
  '3.50-3.99',

  '4.00-4.49',
  '4.50-4.99',

  '5.00-100',
];

export function getSoldDiamondWithFilter(list = [], stone = {}) {
  if (isEmpty(list)) return [];

  const MASTER = Storage.get('dn-master');
  const SHAPE_LIST = find(MASTER?.SHAPE ?? [], { code: stone.shpNm })?.likeKeyWords ?? null;

  const crtRange = (() => {
    const output = isArray(MASTER?.SIZE) ? MASTER?.SIZE?.map((size) => size.group) : caratRange;
    return uniq(output);
  })();

  const group = crtRange?.filter((el) => {
    return parseFloat(el.split('-')[0]) <= stone.crt && parseFloat(el.split('-')[1]) >= stone.crt;
  });
  const from = parseFloat(group[0]?.split('-')?.[0]);
  const to = parseFloat(group[0]?.split('-')?.[1]);

  const output = (() => {
    const _list = list?.filter(
      (_stone) =>
        _stone.crt >= from &&
        _stone.crt <= to &&
        _stone.colNm &&
        _stone.colNm === stone.colNm &&
        _stone.clrNm === stone.clrNm &&
        _stone.cutNm === stone.cutNm &&
        _stone.polNm === stone.polNm &&
        _stone.symNm === stone.symNm &&
        _stone.fluNm === stone.fluNm,
    );
    return !SHAPE_LIST
      ? _list?.filter((_stone) => _stone.shpNm === stone.shpNm)
      : _list?.filter((_stone) => _stone.shpNm === stone.shpNm || SHAPE_LIST.includes(_stone.shpNm));
  })();

  return output;
}

const offerCaratGrp = [
  '0.01-0.09',
  '0.10-0.19',
  '0.20-0.29',
  '0.30-0.39',
  '0.40-0.49',
  '0.50-0.59',
  '0.60-0.69',
  '0.70-0.79',
  '0.80-0.89',
  '0.90-0.99',
  '1.00-1.49',
  '1.50-1.99',
  '2.00-2.99',
  '3.00-3.99',
  '4.00-4.99',
  '5.00-100.00',
];

class Offer extends Component {
  state = {
    data: [],
    checked: [],
    columns: [],
    collapseAll: false,
    hideRange: false,
    tracks: [],
    showOffer: false,
    historyData: [],
    showHistory: [],
    VALUES: {},
    checkedData: [],
    client: this.props.client ?? {},
  };

  getHistoryData = async () => {
    const request = {
      from: moment().add(-1, 'month').toISOString(),
      to: moment().toISOString(),
    };

    this.setState({ historyLoading: true });
    const [err, res] = await historyDataPaginate(request);

    if (!err && res?.code === 'OK' && res?.data?.list.length) {
      let historyData = [];
      res.data.list.forEach((x) => {
        x.memoDetails.forEach((m) => {
          m.user = x.user;
          m.date = x.updatedAt;
        });
        historyData = [...historyData, ...x.memoDetails];
      });
      this.setState({ historyData }, () => this.fetchData(this.state.data));
      this.setState({ historyLoading: false });
    }
  };

  componentDidMount() {
    this.setState({ tracks: isArray(this.props.tracks) ? this.props.tracks : [] });
    this.getColumns();
    this.setData();
  }

  getConfig = async () => {
    const [err, res] = await getOfficeConfig({});
  };

  getColumns = () => {
    let columns = [
      {
        Header: 'SID',
        id: 'vStnId',
        accessor: 'vStnId',
        Cell: ({ row }) => <a className="tableLink">{row.original.vStnId}</a>,
      },
      {
        Header: 'CT.',
        accessor: 'crt',
        id: 'crt',
        Cell: ({ cell }) => <>{parseFloat(cell.value || 0).toFixed(2)}</>,
      },
      {
        Header: 'Shape',
        accessor: 'shpNm',
        id: 'shpNm',
      },
      {
        Header: 'Color',
        accessor: 'colNm',
        id: 'colNm',
      },
      {
        Header: 'Clarity',
        accessor: 'clrNm',
        id: 'clrNm',
      },
      {
        Header: 'Flu',
        accessor: 'fluNm',
        id: 'fluNm',
      },
      {
        Header: 'Cut',
        accessor: 'cutNm',
        id: 'cutNm',
      },
      {
        Header: 'Pol',
        accessor: 'polNm',
        id: 'polNm',
      },
      {
        Header: 'Syn',
        accessor: 'symNm',
        id: 'symNm',
      },
      {
        Header: 'Rap',
        accessor: 'rap',
        id: 'rap',
        Cell: ({ cell }) => <>{parseFloat(cell.value || 0).toFixed(0)}</>,
      },
      // {
      //   Header: 'LAP %',
      //   id: 'buyBack',
      //   accessor: 'buyBack',
      //   Cell: ({ cell }) => <a className="rapPrice">{parseFloat(cell.value || 0).toFixed(2)}</a>,
      // },
      // {
      //   Header: 'Price',
      //   accessor: 'buyCtPr',
      //   id: 'buyCtPr',
      //   Cell: ({ cell, row }) => (
      //     <a className="rapPrice">
      //       {parseFloat(cell.value || (row.original.buyAmt || 0) / row.original.crt).toFixed(2)}
      //     </a>
      //   ),
      // },
      // {
      //   Header: 'Amount',
      //   accessor: 'buyAmt',
      //   id: 'buyAmt',
      //   Cell: ({ cell }) => <a className="rapPrice">{parseFloat(cell.value || 0).toFixed(2)}</a>,
      // },
      {
        Header: 'Ask%',
        accessor: 'back',
        id: 'back',
        Cell: ({ cell, row }) => (
          <a className="askingPrice">
            {row.original.ctPr < row.original.rap
              ? `-${parseFloat(Math.abs(cell.value)).toFixed(2)}`
              : cell.value === 0
              ? Math.abs(cell.value)
              : `+${parseFloat(Math.abs(cell.value)).toFixed(2)}`}
          </a>
        ),
      },
      {
        Header: 'Price/Ct',
        accessor: 'ctPr',
        id: 'ctPr',
        Cell: ({ cell }) => <a className="askingPrice">{parseFloat(cell.value || 0).toFixed(2)}</a>,
      },
      {
        Header: 'Sale Amt',
        accessor: 'amt',
        id: 'amt',
        Cell: ({ cell }) => <a className="askingPrice">{parseFloat(cell.value || 0).toFixed(2)}</a>,
      },
      {
        Header: 'Disc. Diff.',
        id: 'diff',
        accessor: 'diff',
        Cell: ({ row }) => {
          const inputRef = React.useRef();
          const prevValueRef = React.useRef();

          const [value, setValue] = React.useState(row.original.diff);

          React.useEffect(() => {
            if (prevValueRef.current !== row.original.diff) {
              inputRef.current.value = row.original.diff;
              prevValueRef.current = row.original.diff;
              setValue(row.original.diff);
            }
          }, [row.original.diff]);

          const handleInputChange = (e) => {
            setValue(e.target.value);
          };

          const sign = Number(value) > 0 ? '+' : '';
          return (
            <div className="tableInput">
              <span className="add-sign">{sign}</span>
              <input
                style={{ paddingLeft: Number(value) > 0 ? 8 : 2 }}
                ref={inputRef}
                onChange={handleInputChange}
                onBlur={(e) => this.onChangeDiff(e.target.value, row.original.id)}
              />
            </div>
          );
        },
      },
      {
        Header: 'Dis%',
        id: 'discount',
        accessor: 'discount',
        Cell: ({ row }) => {
          const inputRef = React.useRef();
          const prevValueRef = React.useRef();

          const [value, setValue] = React.useState(row.original.discount);

          React.useEffect(() => {
            if (prevValueRef.current !== row.original.discount) {
              inputRef.current.value = row.original.discount;
              prevValueRef.current = row.original.discount;
              setValue(row.original.discount);
            }
          }, [row.original.discount]);

          const handleInputChange = (e) => {
            setValue(e.target.value || 0);
          };

          const sign = Number(value) > 0 ? '+' : '';
          return (
            <div className="tableInput">
              <span className="add-sign">{sign}</span>
              <input
                style={{ paddingLeft: Number(value) > 0 ? 8 : 2 }}
                ref={inputRef}
                onChange={handleInputChange}
                onBlur={(e) => this.onChangeDiscount(e.target.value || 0.0, row.original.id)}
              />
            </div>
          );
        },
      },
      {
        Header: 'Final',
        id: 'final',
        accessor: 'final',
        Cell: ({ row }) => {
          let finalAmt = (row.original.discount / 100 + 1) * row.original.rap * row.original.crt;
          let differ = parseFloat(finalAmt - row.original.buyAmt || 0).toFixed(2);
          return (
            <>
              <span>{parseFloat(finalAmt || 0).toFixed(2)}</span>
              {/* <span className={differ > 0 ? 'greenColor' : 'redColor'}> ({differ})</span> */}
            </>
          );
        },
      },
      // {
      //   Header: 'Active Offer',
      //   accessor: 'activeOffer',
      //   id: 'activeOffer',
      //   Cell: ({ row }) => {
      //     let offers = this.state.tracks?.filter((el) => el.diamond === row.original.id);
      //     let count = offers.length;
      //     return !count ? (
      //       <div>{count}</div>
      //     ) : (
      //       <Popover
      //         placement="topLeft"
      //         content={
      //           <div>
      //             {offers?.map((item, index) => {
      //               return (
      //                 <ActiveOfferDetail
      //                   key={index}
      //                   name={
      //                     item.user && typeof item.user === 'object'
      //                       ? `${item.user.firstName} ${item.user.lastName}`
      //                       : '-'
      //                   }
      //                   offer={parseFloat(item.newDiscount).toFixed(2) + '%'}
      //                   diff={parseFloat(item.newDiscount - row.original.back).toFixed(2) + '%'}
      //                   date={item.createdAt ? moment(item.createdAt).format('DD/MM/YYYY') : '-'}
      //                 />
      //               );
      //             })}
      //           </div>
      //         }
      //         title={false}
      //       >
      //         <div>{count}</div>
      //       </Popover>
      //     );
      //   },
      // },
      // {
      //   Header: 'Historical Column',
      //   id: 'history',
      //   accessor: 'history',
      //   Cell: ({ row }) => (
      //     <OfferHistoryCell
      //       loading={this.state.historyLoading}
      //       row={row.original}
      //       history={this.state.historyData}
      //       onClick={this.showHistory}
      //     />
      //   ),
      // },
      // {
      //   Header: 'Pointer',
      //   id: 'offerGrp',
      //   accessor: 'offerGrp',
      // },
      // {
      //   Header: 'Rap Avg',
      //   id: 'rapAvg',
      //   accessor: 'rapAvg',
      //   Cell: ({ row }) => parseFloat(row.original.rap * row.original.crt).toFixed(2),
      // },
      this.props.inOffer
        ? {
            Header: 'Bargains',
            accessor: 'bargains',
            Cell: ({ row }) => (
              <div className="d-flex">
                {row.original?.bargains?.length === 0 && '-'}
                {row.original?.bargains?.slice(0, 3)?.map((x, index) => (
                  <span key={index} className={`offerPrice ${x.type}`}>
                    <Tooltip title={x.time}>
                      <span>{x.offer}</span>
                    </Tooltip>
                  </span>
                ))}
                {row.original?.bargains?.length > 3 && (
                  <Popover
                    content={
                      <>
                        {row.original?.bargains?.map((x, index) => (
                          <span key={index} className={`offerPrice ${x.type}`}>
                            <Tooltip title={x.time}>
                              <span>{x.offer}</span>
                            </Tooltip>
                          </span>
                        ))}
                      </>
                    }
                  >
                    <span className="moreValue">
                      <img src={require('assets/svg/InventoryResult/more-black.svg')} alt="" />
                    </span>
                  </Popover>
                )}
              </div>
            ),
          }
        : null,
    ]?.filter((el) => el && el);

    this.setState({ columns }, () => this.fetchData());
  };

  showHistory = (vStnId) => {
    let showHistory = this.state.showHistory;
    if (showHistory.includes(vStnId)) showHistory = showHistory?.filter((el) => el !== vStnId);
    else showHistory.push(vStnId);
    this.setState({ showHistory });
  };

  fetchData = (list, updateDiscount = true, newDisc = false, newDiff = false) => {
    let twoCall = uniq(this.props.checked?.map((x) => (x.newDiscount ? 'update' : 'add')));
    if (twoCall.length > 1) this.setState({ twoCall: true });
    let offerCrtGroup = this.props.checked
      ?.map((x) => (x.sizeGrp ? x.sizeGrp.replace(/' '/g, '') : ''))
      ?.filter((el) => el && el);
    if (!offerCrtGroup?.length) offerCrtGroup = offerCaratGrp;

    let data = list
      ? list
      : [...this.props.checked]
          ?.map((x) => {
            let grp = offerCrtGroup?.filter((el) => el.split('-')[0] <= x.crt && el.split('-')[1] >= x.crt)[0];
            return {
              ...x,
              discount: parseFloat((this.props.inOffer ? x.newDiscount : x.back) || 0).toFixed(2),
              diff: parseFloat(this.props.inOffer ? x.newDiscount - x.back : 0).toFixed(2),
              offerGrp: grp ?? offerCrtGroup[offerCrtGroup.length - 1],
            };
          })
          ?.sort((b, a) => a.crt - b.crt);

    data?.length &&
      [...data].forEach((val, i) => {
        if (!data[i - 1] || data[i - 1].offerGrp !== val.offerGrp) {
          val.isOfferHeader = true;
          // val.diffIndex = findIndex(this.state.columns, { id: 'diff' });
          val.calc = [''];
          let rapAvg = sum(data?.filter((el) => el.offerGrp === val.offerGrp).map((d) => d.crt * d.rap));
          let calcCrt = sum(data?.filter((el) => el.offerGrp === val.offerGrp).map((d) => d.crt));
          let calcAmt = sum(data?.filter((el) => el.offerGrp === val.offerGrp).map((d) => d.buyAmt || 0));
          let calcPr = calcCrt ? calcAmt / calcCrt : 0;
          let calcBack = calcCrt ? (calcPr / (rapAvg / calcCrt) - 1) * 100 : 0;
          let amt = sum(data?.filter((el) => el.offerGrp === val.offerGrp).map((d) => d.amt));
          let ctPr = calcCrt ? amt / calcCrt : 0;
          let back = calcCrt ? (ctPr / (rapAvg / calcCrt) - 1) * 100 : 0;
          let finalCalc = sum(
            data?.filter((el) => el.offerGrp === val.offerGrp).map((d) => (d.discount / 100 + 1) * d.rap * d.crt),
          );
          let differCalc = parseFloat(finalCalc - calcAmt || 0).toFixed(2);
          return this.state.columns.forEach((col) => {
            if (col.id === 'crt') val.calc.push(parseFloat(calcCrt).toFixed(2));
            else if (col.id === 'diff')
              val.calc.push(<CellInputHeader onChange={this.diffChange} args={val?.offerGrp} inputOnly />);
            else if (col.id === 'discount')
              val.calc.push(<CellInputHeader onChange={this.discChange} args={val?.offerGrp} inputOnly />);
            else if (col.id === 'buyBack') val.calc.push(parseFloat(calcBack).toFixed(2));
            else if (col.id === 'buyCtPr') val.calc.push(parseFloat(calcPr).toFixed(2));
            else if (col.id === 'buyAmt') val.calc.push(parseFloat(calcAmt).toFixed(2));
            else if (col.id === 'back')
              val.calc.push(
                back < 0
                  ? `-${parseFloat(Math.abs(back)).toFixed(2)}`
                  : back === 0
                  ? Math.abs(back)
                  : `+${parseFloat(Math.abs(back)).toFixed(2)}`,
              );
            else if (col.id === 'ctPr') val.calc.push(parseFloat(ctPr).toFixed(2));
            else if (col.id === 'amt') val.calc.push(parseFloat(amt).toFixed(2));
            else if (col.id === 'final')
              val.calc.push(
                <>
                  <span>{parseFloat(finalCalc || 0).toFixed(2)}</span>
                  {/* <span className={differCalc > 0 ? 'greenColor' : 'redColor'}> ({differCalc})</span> */}
                </>,
              );
            else val.calc.push('');
          });
        }
        let sold = getSoldDiamondWithFilter(this.state.historyData, val);
        val.content2 = <OfferWise showHistory sold={sold} isFancy={val.isFcCol} />;
        val.content = (
          <OfferWise
            rap={val.rap}
            isFancy={val.isFcCol}
            offers={this.state.tracks?.filter((el) => el.diamond === val.id)}
          />
        );

        val = { ...val };
      });
    if (updateDiscount) {
      data = data.map((x) => {
        return {
          ...x,
          discount:
            newDisc === true
              ? x.discount
              : (x.ctPr < x.rap
                  ? -1 * Math.abs(parseFloat(x.discount).toFixed(2))
                  : Math.abs(parseFloat(x.discount).toFixed(2))
                ).toFixed(2),
          diff:
            newDiff === true
              ? parseFloat(Number(x.discount) + x.back).toFixed(2)
              : parseFloat(Number(x.discount) - x.back).toFixed(2),
        };
      });
    }
    this.setState({ data, checked: list ? this.state.checked : data?.map((x) => x.id) }, () => {
      if (!list) this.getHistoryData();
    });
  };

  onChangeDiff = (val, id) => {
    let data = [...this.state.data];
    let index = findIndex(data, { id });
    data[index].diff = val ? parseFloat(!val || isNaN(val) ? 0 : val).toFixed(2) : parseFloat(0).toFixed(2);
    data[index].discount =
      parseFloat(parseFloat(data[index].diff) + data[index].back).toFixed(2) || parseFloat(0).toFixed(2);
    if (isNaN(data[index].discount)) data[index].discount = parseFloat(0).toFixed(2);
    data[index] = { ...data[index] };
    this.fetchData(data, false);
  };

  onChangeDiscount = (val, id) => {
    let data = [...this.state.data];
    let index = findIndex(data, { id });
    data[index].discount = val
      ? parseFloat(!val || isNaN(val) ? data[index].discount || 0 : val).toFixed(2)
      : parseFloat(0).toFixed(2);
    data[index].diff = parseFloat(data[index].discount - data[index].back).toFixed(2);
    if (isNaN(data[index].diff)) data[index].diff = parseFloat(0).toFixed(2);
    data[index] = { ...data[index] };
    this.fetchData(data, false);
  };

  diffChange = (val, grp) => {
    let data = this.state.data.map((row) => {
      if (!grp || row.offerGrp === grp) {
        row.diff = parseFloat(!val || isNaN(val) ? 0 : val).toFixed(2);
        row.discount = parseFloat(parseFloat(row.diff) - row.back).toFixed(2);
        if (isNaN(row.discount)) row.discount = parseFloat(0).toFixed(2);
        return { ...row };
      }
      return row;
    });
    this.fetchData(data, true, true, true);
  };

  discChange = (val, grp) => {
    let data = this.state.data.map((row) => {
      if (!grp || row.offerGrp === grp) {
        row.discount = parseFloat(!val || isNaN(val) ? row.discount : val).toFixed(2);
        row.diff = parseFloat(row.discount + row.back).toFixed(2);
        if (isNaN(row.diff)) row.diff = parseFloat(0).toFixed(2);
        return { ...row };
      }
      return row;
    });
    this.fetchData(data, true, true);
  };

  applyOffer = async () => {
    // let values={}
    // ['userAccount', 'user', 'seller', 'broker'].forEach((field) => {
    //   values[field] = values[field]?.id;
    // });
    let arr = this.state.partAdd || this.state.data;
    let checkedData = arr?.filter((el) => this.state.checked.includes(el.id));
    if (!checkedData.length) {
      OpenNotification({ type: 'error', title: Messages.DiamondSelectRequire });
      return;
    }
    const request = {
      trackType: TRACK_TYPES.Offer,
      userAccount: this.state.twoCall ? null : this.props.client && this.props.client.id,
      user: this.state.twoCall
        ? this.props.client && this.props.client.id
        : this.props.client && this.props.client.user && this.props.client.user.id,
      diamonds: checkedData?.map((d) => ({
        diamond: d.id,
        newPricePerCarat: (d.discount / 100 + 1) * d.rap || d.ctPr,
        newAmount: (d.discount / 100 + 1) * d.rap * d.crt || d.amt,
        newDiscount: d.discount || d.back,
        vnd: d.vnd,
        vStnId: d.vStnId,
        // offerValidDate: moment().add(d.hours, 'hours').toISOString(),
      })),
    };
    const [, res] = await createDiamondTrack(request);
    if (res?.code === 'OK') {
      // this.props.fetch()
      OpenNotification({ type: 'success', title: res.message });
      this.props.onClose();
      this.props.fetch();
      RowSelectService.resetSelectedRows({ currentType: 'transactionOffer' });
    }
  };

  updateOffer = async () => {
    let arr = filterList(this.state.partUp || this.state.data);
    let checkedData = arr?.filter((el) => this.state.checked.includes(el.id));
    if (!checkedData.length) {
      OpenNotification({ type: 'error', title: Messages.DiamondSelectRequire });
      return;
    }
    let obj = CommonApi.Offer.Counter;
    obj.request = {
      tracks: checkedData?.map((d) => ({
        id: d.blockId,
        diamond: d.id,
        newPricePerCarat: (d.discount / 100 + 1) * d.rap || d.ctPr,
        newAmount: (d.discount / 100 + 1) * d.rap * d.crt || d.amt,
        newDiscount: parseFloat(d.discount || d.back),
        offerValidDate: d.offerValidDate,
        userAccount: d.userAccount,
        user: d.user.id, // this.props.client && this.props.client.id,
      })),
    };
    UtilService.callApi(obj, (err, res) => {
      if (res?.code === 'OK') {
        this.props.fetch();
        RowSelectService.resetSelectedRows({ currentType: 'transactionOffer' });
        if (!this.state.twoCall) OpenNotification({ type: 'success', title: res.message });
        this.props.onClose();
      }
    });
  };

  addDiamond = () => {
    let data = this.state.data;
    Storage.set('addDiamond', data);
    searchFn({}, (err, cb) => {
      Storage.set(
        'cli',
        this.props.client.user
          ? { ...this.props.client.user, companyName: this.props.client.companyName }
          : this.props.client,
      );
      if (cb && cb.searchIds)
        this.props.history.push(`/mohit-diamond/inventory/single-stone/search?result=${cb.searchIds.join(',')}`, {
          customer: this.props.client,
        });
    });
  };

  twoCall = () => {
    let partAdd = this.state.data?.filter((el) => !el.newDiscount);
    let partUp = this.state.data?.filter((el) => el.newDiscount);
    this.setState({ partAdd, partUp }, () => {
      this.updateOffer();
      this.applyOffer();
    });
  };

  setData = () => {
    let checkedData = this.state.data?.filter((el) => this.state.checked.includes(el.id));
    let totalRapAvg = sum(checkedData?.map((d) => d.crt * d.rap));
    let totalCt = sum(checkedData?.map((d) => d.crt));
    let totalLapAmt = sum(checkedData?.map((d) => d.buyAmt || 0));
    let totalLapPr = totalCt ? totalLapAmt / totalCt : 0;
    let totalLap = totalCt ? (totalLapPr / (totalRapAvg / totalCt) - 1) * 100 : 0;
    let totalAmt = sum(checkedData?.map((d) => d.amt));
    let totalCtPr = totalCt ? totalAmt / totalCt : 0;
    let totalBack = totalCt ? (totalCtPr / (totalRapAvg / totalCt) - 1) * 100 : 0;
    let totalFinalCalc = sum(checkedData?.map((d) => (d.discount / 100 + 1) * d.rap * d.crt));
    let totalOfferRate = totalCt ? totalFinalCalc / totalCt : 0;
    let totalOffer = totalCt ? (totalOfferRate / (totalRapAvg / totalCt) - 1) * 100 : 0;
    let totalDifferCalc = totalOffer - totalBack;

    let VALUES = {
      'CT.': totalCt,
      'Rap%': totalLap,
      'Rap Rate': totalLapPr,
      'Rap value': totalLapAmt,
      'Ask%': totalBack,
      'Asking Rate': totalCtPr,
      'Asking Value': totalAmt,
      'Offer%': totalOffer,
      'Offer Rate': totalOfferRate,
      'Offer Value': totalFinalCalc,
      'Discount Different': totalDifferCalc,
      'P/L Amt': totalFinalCalc - totalLapAmt,
      'P/L %': totalLapAmt ? ((totalFinalCalc - totalLapAmt) * 100) / totalLapAmt : 0,
    };

    this.setState({
      checkedData: [...this.state.checkedData, ...checkedData],
      VALUES: { ...this.state.VALUES, ...VALUES },
    });
  };

  componentDidUpdate(prevProps, prevState) {
    if (prevState.data !== this.state.data) {
      this.setData();
    }
  }

  handleCheck = (checked) => this.setState({ checked: checked?.map((x) => x.id) });

  handleToggle = (collapsed, grp) => {
    let data = this.state.data.map((row) => {
      if (row.offerGrp === grp) {
        row.collapsed = collapsed;
        return { ...row };
      }
      return row;
    });
    this.setState({ data });
  };

  render() {
    let { client } = this.state;

    return (
      <div className="offerMainPage">
        <div className="d-flex align-items-center justify-space-between  offerTopBlock">
          <div className="d-flex align-items-center">
            <CommonBackButton onClick={this.props.onClose} />
            <div className="offerTitleWithClient">
              <h2>Apply Quote For</h2>
              <div className="clientDetail">
                <div className="listdetailBox listClientName">
                  <div className="d-flex align-items-center">
                    <span className="listClientNameBox">{client.companyName || ''}</span>
                    <span className="liveStatus  offline"></span>
                  </div>
                </div>
                <div className="listdetailBox listUserList">
                  <div className="d-flex align-items-center">
                    <span>
                      {(client.user && client.user.firstName) || client.firstName || ''}{' '}
                      {(client.user && client.user.lastName) || client.lastName || ''}
                    </span>
                    <span> | {(client.user && client.user.mobile) || client.mobile || ''}</span>
                    <span className="kycStatus active">Active</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="offerTopCollpaseOption">
            {/* <div>
              <Checkbox
                value={this.state.showOffer}
                onChange={() => this.setState((prev) => ({ showOffer: !prev.showOffer }))}
              >
                Show offer on stone
              </Checkbox>
            </div> */}
            {/* <CollpaseBox
              title1="Collapse All"
              title2="Expand All"
              collpase={!this.state.collapseAll && 'active'}
              collpase1={this.state.collapseAll && 'active'}
              collpaseAllOption={() => {
                this.setState({ collapseAll: !this.state.collapseAll }, () => {
                  let data = this.state.data;
                  data.forEach((val) => (val.collapsed = this.state.collapseAll));
                  this.setState({ data, hideRange: this.state.collapseAll ? false : this.state.hideRange });
                });
              }}
            />
            <CollpaseBox
              title1="Add Range"
              title2="Hide Range"
              collpase={!this.state.hideRange && 'active'}
              collpase1={this.state.hideRange && 'active'}
              collpaseAllOption={() => {
                this.setState(
                  {
                    hideRange: !this.state.hideRange,
                    collapseAll: !this.state.hideRange ? false : this.state.collapseAll,
                  },
                  () => {
                    let data = this.state.data;
                    data.forEach((val) => (val.collapsed = this.state.collapseAll));
                    this.setState({ data });
                  },
                );
              }}
            /> */}
            {/* <button className="commonButton smallButton" onClick={this.addDiamond}>
              Add Diamond
            </button> */}
            <button
              className="commonButton smallButton ml-5"
              onClick={this.state.twoCall ? this.twoCall : this.props.inOffer ? this.updateOffer : this.applyOffer}
            >
              Apply Quote
            </button>
          </div>
        </div>
        <ListingWrapper className="offerTable">
          <ListingTableWrapper
            className="tabInnerTableScroll"
            subtractFrom=".offerTopBlock,.botoomStickyBar"
            adjustment={-10}
          >
            <Table
              noDnd
              noDots
              columns={this.state.columns}
              colspan={1}
              data={this.state.data}
              handleCheck={this.handleCheck}
              checked={this.state.checkedData}
              noGrp={this.state.hideRange ? true : false}
              toggleCollapse={this.handleToggle}
              showOffer={this.state.showOffer}
              showHistory={this.state.showHistory}
              isOfferPopup
            />
            <div className="botoomStickyBar align-items-center flex-wrap">
              {Object.keys(this.state.VALUES)?.map((x, index) => {
                return (
                  <div key={index} className="bottomValue">
                    <span>{x}</span>
                    <span>{parseFloat(this.state.VALUES[x]).toFixed(2)}</span>
                  </div>
                );
              })}
            </div>
          </ListingTableWrapper>
        </ListingWrapper>
      </div>
    );
  }
}

export default withRouter(Offer);
